import {React} from 'react'
import ShoppingMenu from '../assets/Menu.png'
import Stockz from '../assets/stockz.png'
import Tours from '../assets/tour.png'
import CloudHost from '../assets/cloudhosting.png'
const Work = () => {
    // const [isDemo, setDemo] = useState(false);
    // const onDemoHandler = ()=> {
    //     setDemo(true);
    
  return (
    <div name='work' className='w-full md:h-screen text-gray-300 bg-[#0a192f]'>
        <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full ' >
            <div className='pb-8' >
                <p className='text-4xl font-bold inline border-b-4 text-gray-300 border-green-600' >Work</p>
                <p className='py-6' >These are some of the projects I recently worked on</p>
            </div>
            <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4'>
                <div style={{backgroundImage:  `url(${CloudHost})`}}  className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div '>

                    {/* Hover Effects */}
                    <div className='opacity-0 group-hover:opacity-100'>
                         <span className='text-2xl font-bold text-white tracking-wider' >
                            Html and Css
                        </span>
                            <div className='pt-8 text-center' >
                                
                                    <a href="https://5moshifyyywolfgang.netlify.app"><button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold txt-lg'>Demo</button></a>
                                   <a href="https://github.com/Wgang231/Joggy"><button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg' >Code</button></a>
                            </div>
                        
                    </div>
                </div>
                <div style={{backgroundImage:  `url(${ShoppingMenu})`}}  className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div '>

                    {/* Hover Effects */}
                    <div className='opacity-0 group-hover:opacity-100'>
                         <span className='text-2xl font-bold text-white tracking-wider' >
                            React JS Application
                        </span>
                            <div className='pt-8 text-center' >
                                    <a href="https://shopping-menu-demo.netlify.app/"><button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold txt-lg'>Demo</button></a>
                                    <a href="https://github.com/Wgang231/Shopping-Menu"><button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg' >Code</button></a>
                            </div>
                        
                    </div>
                </div>
                <div style={{backgroundImage:  `url(${Stockz})`}}  className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div '>

                    {/* Hover Effects */}
                    <div className='opacity-0 group-hover:opacity-100'>
                         <span className='text-2xl font-bold text-white tracking-wider' >
                            JS Application
                        </span>
                            <div className='pt-8 text-center' >
                                
                                    <a href="https://www3scrolljs.netlify.app"><button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold txt-lg'>Demo</button></a>
                                    <a href="https://github.com/Wgang231/Scroll"><button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg' >Code</button></a>
                            </div>
                        
                    </div>
                </div>
                <div style={{backgroundImage:  `url(${Tours})`}}  className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div '>

                    {/* Hover Effects */}
                    <div className='opacity-0 group-hover:opacity-100'>
                         <span className='text-2xl font-bold text-white tracking-wider' >
                            React JS Application
                        </span>
                            <div className='pt-8 text-center' >
                                
                                <a href="https://tour-demo-add-remove.netlify.app"><button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold txt-lg'>Demo</button></a>
                                <a href="https://github.com/Wgang231/Tours"><button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg' >Code</button></a>
                            </div>
                        
                    </div>
                </div>
            </div>
        </div>
        </div>
  )
}

export default Work